import { mergeLocale} from 'antd-mobile/es/utils/merge-locale'
import { base } from 'antd-mobile/es/locales/base';
const typeTemplate = '${label} ${type} के रूप में स्वीकार नहीं किया गया';

const hiIN = mergeLocale(base, {
  'locale': 'hi-IN',
  common: {
    confirm: 'पुष्टि करें',
    cancel: 'रद्द करें',
    loading: 'लोड हो रहा है',
    close: 'बंद करें'
  },
  Calendar: {
    title: 'तारीख़ चुनें',
    confirm: 'पुष्टि करें',
    start: 'शुरुआत',
    end: 'अंत',
    today: 'आज',
    markItems: ['सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार', 'रविवार'],
    yearAndMonth: '${year}/${month}'
  },
  Cascader: {
    placeholder: 'चुनें'
  },
  Dialog: {
    ok: 'ठीक है'
  },
  DatePicker: {
    tillNow: 'अब तक'
  },
  ErrorBlock: {
    default: {
      title: 'उफ़, कुछ गलत हो गया',
      description: 'कृपया एक मिनट प्रतीक्षा करें और पुनः प्रयास करें'
    },
    busy: {
      title: 'उफ़, लोड नहीं हो रहा',
      description: 'पृष्ठ को रीफ्रेश करें'
    },
    disconnected: {
      title: 'नेटवर्क कनेक्ट नहीं है',
      description: 'पृष्ठ को रीफ्रेश करें'
    },
    empty: {
      title: 'उफ़, हमें यह नहीं मिला...',
      description: 'क्या आप नई खोज करना चाहेंगे?'
    }
  },
  Form: {
    required: 'आवश्यक',
    optional: 'वैकल्पिक',
    defaultValidateMessages: {
      default: '${label} फ़ील्ड का सत्यापन त्रुटि',
      required: 'कृपया ${label} दर्ज करें',
      enum: '${label} इनमें से एक होना चाहिए [${enum}]',
      whitespace: '${label} खाली स्थान नहीं हो सकता',
      date: {
        format: '${label} की तारीख़ का प्रारूप गलत है',
        parse: '${label} को तारीख़ में परिवर्तित नहीं किया जा सकता',
        invalid: '${label} अमान्य तारीख़ है'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} ${len} अक्षर का होना चाहिए',
        min: '${label} कम से कम ${min} अक्षर का होना चाहिए',
        max: '${label} अधिक से अधिक ${max} अक्षर का होना चाहिए',
        range: '${label} ${min}-${max} अक्षरों के बीच होना चाहिए'
      },
      number: {
        len: '${label} ${len} के बराबर होना चाहिए',
        min: '${label} कम से कम ${min} होना चाहिए',
        max: '${label} अधिक से अधिक ${max} होना चाहिए',
        range: '${label} ${min}-${max} के बीच होना चाहिए'
      },
      array: {
        len: '${label} ${len} आइटम होने चाहिए',
        min: '${label} कम से कम ${min} आइटम होने चाहिए',
        max: '${label} अधिक से अधिक ${max} आइटम होने चाहिए',
        range: '${label} की संख्या ${min}-${max} के बीच होनी चाहिए'
      },
      pattern: {
        mismatch: '${label} ${pattern} मानदंडों को पूरा नहीं करता'
      }
    }
  },
  ImageUploader: {
    uploading: 'अपलोड हो रहा है...',
    upload: 'अपलोड करें'
  },
  InfiniteScroll: {
    noMore: 'अधिक जानकारी नहीं है',
    failedToLoad: 'लोड करने में विफल',
    retry: 'पुनः प्रयास करें'
  },
  Input: {
    clear: 'साफ़ करें'
  },
  Mask: {
    name: 'मास्क'
  },
  Modal: {
    ok: 'ठीक है'
  },
  PasscodeInput: {
    name: 'पासकोड दर्ज करें'
  },
  PullToRefresh: {
    pulling: 'रीफ्रेश करने के लिए नीचे खींचें',
    canRelease: 'तुरंत रीफ्रेश करने के लिए छोड़ें',
    complete: 'रीफ्रेश सफलतापूर्वक पूर्ण हुआ'
  },
  SearchBar: {
    name: 'खोज पैनल'
  },
  Slider: {
    name: 'स्लाइडर'
  },
  Stepper: {
    decrease: 'घटाएँ',
    increase: 'बढ़ाएँ'
  },
  Switch: {
    name: 'स्विच'
  },
  Selector: {
    name: 'चयनकर्ता'
  }
});
export default hiIN;
